import { ExamplePageTemplate } from "./components";
import { restaurantConfig } from "./configs/exampleConfigs";

const RestaurantExample = () => {
  return (
    <ExamplePageTemplate
      backgroundColor={restaurantConfig.backgroundColor}
      chatButtonColor={restaurantConfig.chatButtonColor}
      chatButtonIcon={restaurantConfig.chatButtonIcon}
      header={restaurantConfig.header}
      hero={restaurantConfig.hero}
    >
      {restaurantConfig.content}
    </ExamplePageTemplate>
  );
};

export default RestaurantExample;